import { render, staticRenderFns } from "./OverseasEnthusiasm.vue?vue&type=template&id=4fff4dd0&scoped=true"
import script from "./OverseasEnthusiasm.vue?vue&type=script&lang=js"
export * from "./OverseasEnthusiasm.vue?vue&type=script&lang=js"
import style0 from "./OverseasEnthusiasm.vue?vue&type=style&index=0&id=4fff4dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff4dd0",
  null
  
)

export default component.exports